export default __webpack_public_path__ + "static/media/testimonials-5.8732aa37.jpg";